var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "mt-3 mb-2" }, [
      _c(
        "table",
        {
          staticClass: "table tablerow",
          attrs: {
            "aria-label": _vm.title ? null : _vm.$t("Attachment.Attachments")
          }
        },
        [
          _vm.title
            ? _c(
                "caption",
                [
                  _c("plain-text-control", {
                    attrs: { title: _vm.title, required: _vm.required }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", [
                _c("span", { attrs: { id: "description_label" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("Correspondence.Attachment.Description"))
                  )
                ])
              ]),
              _vm._v(" "),
              _c("th", [
                _c("span", [_vm._v(_vm._s(_vm.$t("Attachment.Downloaded")))])
              ]),
              _vm._v(" "),
              _c("th", [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("Attachment.DownloadOrRemove")))
                ])
              ]),
              _vm._v(" "),
              _c("th", [
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(_vm.$t("Correspondence.Accessibility.Action")))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.kAttachmentsData.kattachments, function(ka, index) {
              return _c(
                "tr",
                { key: ka.key, staticClass: "paddingless" },
                [
                  ka.attachment.displayKey
                    ? _c(
                        "th",
                        { staticClass: "w-40 normal row-heading" },
                        [
                          _c("plain-text-control", {
                            attrs: {
                              title: ka.attachment.displayKey,
                              required: ka.attachment.isRequired,
                              noMargin: true
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "td",
                        { staticClass: "input-cell" },
                        [
                          _c("text-area-control", {
                            class: _vm.attachmentNameClass(
                              ka.attachment.name,
                              index,
                              _vm.$attrs.id
                            ),
                            attrs: {
                              rows: 1,
                              maxLength: _vm.attachmentNameMaxLength,
                              required: _vm.nameRequired(ka),
                              disabled: _vm.$attrs.disabled,
                              placeholderKey: _vm.textPlaceholder,
                              labelledBy: "description_label"
                            },
                            model: {
                              value: ka.attachment.name,
                              callback: function($$v) {
                                _vm.$set(ka.attachment, "name", $$v)
                              },
                              expression: "ka.attachment.name"
                            }
                          })
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      class: {
                        normal: true,
                        "validation-error":
                          !_vm.uploading.includes(index) &&
                          _vm.kAttachmentsData.isFileNameDuplicate(
                            ka.attachment.fileNameWithExtension
                          )
                      }
                    },
                    [
                      _vm.uploading.includes(index)
                        ? _c("span", [
                            _c("i", [
                              _vm._v(_vm._s(_vm.$t("Attachment.Downloading")))
                            ])
                          ])
                        : _c("span", [
                            ka.attachment.fileNameWithExtension
                              ? _c("span", [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        ka.attachment.fileNameWithExtension
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  !_vm.uploading.includes(index) &&
                                  _vm.kAttachmentsData.isFileNameDuplicate(
                                    ka.attachment.fileNameWithExtension
                                  )
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Validation.DuplicateAttachmentFileName"
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !ka.attachment.fileNameWithExtension
                              ? _c("i", [
                                  _vm._v(_vm._s(_vm.$t("Attachment.NoFile")))
                                ])
                              : _vm._e()
                          ])
                    ]
                  ),
                  _vm._v(" "),
                  !ka.attachment.displayKey
                    ? _c("attachment-wrapper-table-cell", {
                        key: "attachment-" + index,
                        attrs: {
                          inputId: "attachment-" + index,
                          x: _vm.setRequired(ka),
                          attachment: ka.attachment,
                          notifyonuploadedsuccess: false,
                          validateImmediately: _vm.validateImmediately,
                          allowedExtensions: _vm.allowedExtensions,
                          refreshValidationKey: ka.attachment.name
                            ? ka.attachment.name
                            : "" + index
                        },
                        on: {
                          "start-upload": function($event) {
                            return _vm.startUpload($event, index)
                          },
                          "stop-upload": function($event) {
                            return _vm.stopUpload($event, index)
                          },
                          "deleted-attachment": function($event) {
                            return _vm.deletedAttachment($event, ka.attachment)
                          },
                          "added-attachment": function($event) {
                            return _vm.addedAttachment($event, ka.attachment)
                          }
                        }
                      })
                    : _c("attachment-wrapper-table-cell", {
                        key: "attachment-" + index,
                        attrs: {
                          inputId: "attachment-" + index,
                          attachment: ka.attachment,
                          notifyonuploadedsuccess: false,
                          validateImmediately: _vm.validateImmediately,
                          allowedExtensions: _vm.allowedExtensions,
                          refreshValidationKey: ka.attachment.name
                            ? ka.attachment.name
                            : "" + index
                        },
                        on: {
                          "start-upload": function($event) {
                            return _vm.startUpload($event, index)
                          },
                          "stop-upload": function($event) {
                            return _vm.stopUpload($event, index)
                          },
                          "deleted-attachment": function($event) {
                            return _vm.deletedAttachment($event, ka.attachment)
                          },
                          "added-attachment": function($event) {
                            return _vm.addedAttachment($event, ka.attachment)
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c("td", { staticClass: "w-5" }, [
                    _vm.showDelete &&
                    _vm.allowDelete(ka.attachment) &&
                    !_vm.isReadOnly
                      ? _c("span", { staticClass: "centered" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-link btn-contrast",
                              attrs: {
                                type: "button",
                                "aria-label":
                                  _vm.$t("Btn_DeleteRow") +
                                  (index + 2) +
                                  " -. " +
                                  _vm.$t("Accessibility.ConfirmDeleteRow")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteRow(ka.key)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-trash-alt fa-lg centered"
                              })
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            }),
            0
          )
        ]
      )
    ]),
    _vm._v(" "),
    _vm.showActions && !_vm.isReadOnly
      ? _c("div", [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.addRow()
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("BudgetaryEstimate.Btn_AddRow")) +
                  "\n    "
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }